import { loadECGWaveform } from '../../../utilities/ECGUtilities';
import { getGenericViewportSourceDataId } from '../genericViewportDataSetAccess';
export class DefaultECGDataProvider {
    async load(dataId) {
        const sourceDataId = getGenericViewportSourceDataId(dataId);
        const { waveform } = await loadECGWaveform(sourceDataId);
        return {
            id: dataId,
            type: 'ecg',
            ...waveform,
        };
    }
}
